const isBrowser: boolean = typeof window !== 'undefined';

declare global {
  interface Window {
    Event: typeof Event;
    XMLHttpRequest: typeof XMLHttpRequest;
  }
}

const windowObject: Partial<Window> = isBrowser ? window : {};

export default {
  btoa:
    (windowObject as any).btoa ??
    ((str: string) => (globalThis as any).Buffer.from(str, 'utf-8').toString('base64')),
  isBrowser,
  window: windowObject,
  document: windowObject.document,
  Event: windowObject.Event,
};
